import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';


/**
 * FormLabel Component
 * @param {Object} props
 * @param {string} props.text - 라벨 텍스트
 * @param {boolean} props.required - 필수 여부
 */
export const FormLabel = ({
    text = '대회종목',
    required = false,
    sx = {}
}) => {

    const theme = useTheme();

    return (
        <Typography sx={{
            fontSize: '14px',
            color: theme.palette.figma.white[60],
            fontWeight: 400,
            ...sx
        }}>
            {text}{required && <span style={{ color: theme.palette.figma.Red_didim }}>*</span>}
        </Typography>
    );
};

export default FormLabel;
